const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/jira/callback.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/jira/callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const jiraCallbackSchema = z.object({
  state: z.string(),
  code: z.string().optional(),
  error: z.string().optional()
});
export const Route = createFileRoute('/(app)/integrations/jira/callback')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(jiraCallbackSchema),
  loaderDeps: ({
    search: {
      state,
      code
    }
  }) => ({
    state,
    code
  }),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});